
export const reduxThunkWrapper = async <T>(tryFunction: () => Promise<T>, rejectWithValue: (arg0: unknown) => any) => {
    try {
        return await tryFunction();
    } catch (error) {
        return rejectWithValue(error.response);
    }
}
